import React from 'react'

const TestPage = () => {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">Test Page</h1>
      <p>This is a placeholder for the Test page.</p>
    </div>
  )
}

export default TestPage